<template>
    <div class="smtp-config">
      <h2>Dati SMTP per invio bollettini tramite PEC</h2>
      
      <div class="form-group">
        <label>Server posta in arrivo</label>
        <input 
          type="text" 
          v-model="incomingServer" 
          class="form-control"
          placeholder="es. mail.example.com"
        >
      </div>
      
      <div class="form-group">
        <label>Server posta in uscita</label>
        <input 
          type="text" 
          v-model="outgoingServer" 
          class="form-control"
          placeholder="es. smtp.example.com"
        >
      </div>
      
      <div class="form-row">
        <div class="form-group col-md-6">
          <label>Porta (IMAP)</label>
          <input 
            type="number" 
            v-model="imapPort" 
            class="form-control"
            placeholder="es. 993"
          >
        </div>
        
        <div class="form-group col-md-6">
          <label>Porta (SMTP)</label>
          <input 
            type="number" 
            v-model="smtpPort" 
            class="form-control"
            placeholder="es. 465"
          >
        </div>
      </div>
      
      <div class="form-group">
        <label>E-mail PEC</label>
        <input 
          type="email" 
          v-model="email" 
          class="form-control"
          placeholder="es. tua@pec.example.com"
        >
      </div>
      
      <div class="form-group">
        <label>Password</label>
        <input 
          type="password" 
          v-model="password" 
          class="form-control"
          placeholder="Inserisci la password"
        >
      </div>

      <div class="form-group">
        <label>Data Ultima Modifica</label>
        <input 
          v-model="dateEdited" 
          class="form-control"
          disabled
        >
      </div>
        <div class="form-group">
          <label>Email di test</label>
          <input 
            type="email" 
            v-model="testEmailRecipient" 
            class="form-control"
            placeholder="es. test@example.com"
          >
        </div>
      <div class="form-group form-check">
        <input 
          type="checkbox" 
          v-model="useSSL" 
          class="form-check-input"
          id="sslCheck"
        >
        <label class="form-check-label" for="sslCheck">
          Utilizzare la modalità di crittografia SSL/TLS?
        </label>
      </div>
      
      <button 
        @click="saveData" 
        class="btn btn-primary"
      >
        Salva dati
      </button>
      <button 
        @click="sendTestEmail" 
        class="btn btn-secondary"
      >
        Invia email di test
      </button>
    </div>
  </template>
  
  <script>
  import UserRepository from "../../services/apis/user"
  export default {
    name: 'SmtpConfig',
    data() {
      return {
        incomingServer: '',
        outgoingServer: '',
        imapPort: '',
        smtpPort: '',
        email: '',
        password: '',
        useSSL: true,
        testEmailRecipient: '',
        dateEdited:''
      }
    },
    methods: {
      async sendTestEmail() {
        if (!this.testEmailRecipient) {
          this.$toasted.error('Inserisci l\'email di test').goAway(3000);
          return;
        }
        try {
          const payload = { email: this.testEmailRecipient };
          const response = await UserRepository.send_test_email(payload);
          if (response.data.status === 'success') {
            this.$toasted.success('Email di test inviata con successo').goAway(3000);
          } else {
            this.$toasted.error('Errore durante l\'invio dell\'email di test').goAway(3000);
          }
        } catch (e) {
          console.error(e);
          this.$toasted.error('Errore di rete durante l\'invio dell\'email di test').goAway(3000);
        }
      },
     async saveData() {
        const config = {
            serverInvio: this.outgoingServer,
            serverRicezione: this.incomingServer,
            imapPort: this.imapPort,
            smtpPort: this.smtpPort,
            email: this.email,
            smtpPassword: this.password,
            isSSL: this.useSSL
        }
        // Qui puoi aggiungere la logica per salvare i dati
        try{
            let sendData = await UserRepository.insert_smtp_data(config)
            let getData = await UserRepository.get_smtp_data()
            this.incomingServer =getData.data.smtp['serverRicezione'],
            this.outgoingServer=getData.data.smtp['serverInvio'],
            this.imapPort=getData.data.smtp['imapPort'],
            this.smtpPort=getData.data.smtp['smtpPort'],
            this.email=getData.data.smtp['email'],
            this.useSSL=getData.data.smtp['isSSL'] ?  true :false
            this.dateEdited=getData.data.smtp['date']
            this.password=''
            if(sendData.data.status=="success"){
              this.$toasted.success('Dati Salvati con successo').goAway(3000)
            }else{
              this.$toasted.error("Si è verificato un errore, riprova o contatta l'assistenza").goAway(4000)
            }
            
        }catch(error){
            console.log(error)
        }
      },
      async returnSmtpData(){
        let getData = await UserRepository.get_smtp_data()
        this.incomingServer =getData.data.smtp['serverRicezione'],
        this.outgoingServer=getData.data.smtp['serverInvio'],
        this.imapPort=getData.data.smtp['imapPort'],
        this.smtpPort=getData.data.smtp['smtpPort'],
        this.email=getData.data.smtp['email'],
        this.useSSL=getData.data.smtp['isSSL'] ?  true :false
        this.dateEdited=getData.data.smtp['date']
      }
    },
    mounted(){
      
      this.returnSmtpData()


    }
  }
  </script>
  
  <style scoped>
  .smtp-config {
    max-width: 600px;
    margin: 0 auto;
    padding: 20px;
    background: #f8f9fa;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }
  
  h2 {
    color: #333;
    margin-bottom: 20px;
    font-size: 1.5rem;
  }
  
  .form-group {
    margin-bottom: 1rem;
  }
  
  .form-control {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #ced4da;
    border-radius: 4px;
  }
  
  .form-check {
    display: flex;
    align-items: center;
    margin: 1rem 0;
  }
  
  .form-check-input {
    margin-right: 8px;
  }
  
  .btn-primary {
    background-color: #007bff;
    color: white;
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .btn-primary:hover {
    background-color: #0069d9;
  }
  </style>